package com.xtream.ui.tv.presentation.tvchannels

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.GridView
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.style.TextAlign
import androidx.paging.compose.collectAsLazyPagingItems
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.view_all
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.ui.tv.presentation.common.ContentScreen
import com.xtream.ui.ui.widget.ImageCard
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.rememberAnimatedItemAlpha
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalStdlibApi::class)
@Composable
fun TvChannelsBrowseTvScreen(
    streamControlViewModel: StreamControlViewModel = koinViewModel(),
    rowsContentPadding: PaddingValues,
    contentPadding: PaddingValues,
){
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner
    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val homeScreenPagedItems
            = streamControlViewModel.categoriesPagerWithTvStreams.collectAsLazyPagingItems()

    ContentScreen(
        contentPadding = contentPadding,
        rowsContentPadding = rowsContentPadding,

        carousel = {

        },
        lazyPagingItems = homeScreenPagedItems,
       /* onCategoryClicked = {
            rootNavViewModel.navigate(Screen.LiveTvGrid(it?.categoryId, it?.categoryName))
        },*/
        buildExtraContent = { item, title, rowFocusRequester, columnFocusRequester->


            val categoryId =
                when(item){
                    is LiveStream ->item.categoryId
                    else->null
                }
            ImageCard(
                rememberVectorPainter(Icons.Rounded.GridView),
                title = stringResource(Res.string.view_all),
                textAlign = TextAlign.Center,

                description = "",
                onClick = {
                    columnFocusRequester?.saveFocusedChild()
                    rowFocusRequester?.saveFocusedChild()
                    rootNavViewModel.navigate(Screen.LiveTvGrid(categoryId, title))
                },
                //width =  85.dp,

                aspectRatio = 1f,
              //  dependOnWidth = true,

                )

        }
    ){it ,columnFocusRequester, rowFocusRequester, focusRequester, index, rowListState ->
        val itemAlpha by rowListState.rememberAnimatedItemAlpha( index = index   )

        (it as? LiveStream?)?.let { stream ->
            NetworkImageCard(
                modifier = Modifier.graphicsLayer{
                    alpha=itemAlpha
                }.then(
                    if (focusRequester != null)
                        Modifier.focusRequester(focusRequester)
                    else
                        Modifier
                ),
                src=stream.streamIcon,
                title = stream.name?:"",

                //description = stream.name?:"",
                onClick = {
                    columnFocusRequester?.saveFocusedChild()
                    rowFocusRequester?.saveFocusedChild()

                    rootNavViewModel.navigate(
                        Screen.LiveStreamPlayer(
                            stream.streamId,
                            stream.categoryId,
                            stream.name
                        )
                    )
                },
                aspectRatio = 1f
            )
        }

    }



}